import React from 'react';

export default class Show extends React.Component<{if: boolean}> {
    constructor(props){
        super(props);
    }
    render() {
    return this.props.if ? <span>{this.props.children}</span> : null;
    }
}